<template>
  <b-card id="card-view--plannings">
    <b-card-header
      class="card-image-container p-0 position-relative"
      @click="zoomInPhoto(planning.image_2d)"
    >
      <b-img
        class="w-100 card-image"
        :src="planning.image_2d"
      />
      <feather-icon
        class="position-absolute text-danger zoom-in-icon"
        icon="ZoomInIcon"
        size="35"
      />
    </b-card-header>
    <b-dropdown
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="outline-primary"
      right
      split
      menu-class="drop-up-menu-class w-100"
      toggle-class="p-0 btn-sm"
      class="w-100"
      dropup
    >
      <template #button-content>
        <b-row>
          <b-col cols="8">
            <div class="d-flex">
              <span
                class="bullet svg-font-small-3 mr-50 cursor-pointer"
                :class="`bullet-${active_view.current_status.color}`"
              />
              <span class="font-weight-bold">
                {{ $_moneyFormatter(active_view.total_price) }}
              </span>
            </div>
            <div class="d-flex mt-50">
              <span>
                {{ active_view.total_area.toFixed(2) }}
              </span>
              —
              <span>
                {{ $_moneyFormatter(active_view.price_per_kv) }}/м²
              </span>
            </div>
          </b-col>
          <b-col cols="4">
            <div class="d-flex">
              {{ active_view.stage_floor }} этаж
            </div>
            <div class="d-flex mt-50">
              № {{ active_view.flat_number }}
            </div>
          </b-col>
        </b-row>
      </template>
      <b-dropdown-item
        v-for="flat in planning.flats"
        :key="flat.id"
        @click="chooseFlat(flat)"
      >
        <b-row>
          <b-col cols="7">
            <div>
              <span
                class="bullet svg-font-small-3 mr-50 cursor-pointer"
                :class="`bullet-${flat.current_status.color}`"
              />
              <span class="font-weight-bold">
                {{ $_moneyFormatter(flat.total_price) }}
              </span>
            </div>
            <div>
              <span>
                {{ flat.total_area.toFixed(2) }}
              </span>
              —
              <span>
                {{ $_moneyFormatter(flat.price_per_kv) }}/м²
              </span>
            </div>
          </b-col>
          <b-col cols="5">
            <div>
              {{ flat.stage_floor }} этаж
            </div>
            <div>
              № {{ flat.flat_number }}
            </div>
          </b-col>
        </b-row>
      </b-dropdown-item>
    </b-dropdown>
    <div class="d-flex justify-content-center">
      <b-button
        class="mt-2"
        pill
        variant="primary"
        @click="moreInfoClick(active_view)"
      >
        Подробно
      </b-button>
    </div>
  </b-card>
</template>

<script>
import {
  BRow, BCol, BCard, BCardHeader, BImg, BButton, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import formatters from '@/mixins/extra'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BImg,
    BButton,
    FeatherIcon,
    BDropdown,
    BDropdownItem,
  },
  mixins: [formatters],
  props: {
    planning: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      active_view: {},
    }
  },
  mounted() {
    const [active_flat] = this.planning.flats
    this.active_view = active_flat
  },
  methods: {
    zoomInPhoto(url) {
      this.$parent.$emit('photoClicked', url)
    },
    moreInfoClick(flat) {
      this.$parent.$emit('moreInfoClick', flat)
    },
    chooseFlat(flat) {
      this.active_view = flat
      this.$parent.$emit('flatSelected', flat)
    },
  },
}
</script>

<style lang="scss">
  #card-view--plannings {
    .card-image {
      transition: transform .5s;
    }
    .card-image-container:hover {
      .card-image {
        transform: scale(1.2, 1.2);
        opacity: 0.5;
      }
      .zoom-in-icon {
        transform:  translateX(-50%) scale(1, 1);
      }
    }
    // .card-image:hover {
    //   transform: scale(1.2, 1.2);
    // }
    .card-image-container {
      overflow: hidden;
      cursor: pointer;
    }
    .zoom-in-icon {
      left: 50%;
      transform: translateX(-50%) scale(0, 0);
      transition: transform .3s;
    }
    .drop-up-menu-class {
      max-height: 400px;
      overflow: auto;
    }
  }
</style>
